<template>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Teacher Progress Report">

        <v-card-actions class="button-container d-flex justify-end align-center">
          <v-btn
          :disabled="!progressReportList || progressReportList.length === 0"
           elevation="1" color="primary lighten-2" @click="downloadReportCSV(progressReportList)" > Download as CSV </v-btn>
          <v-btn
          :disabled="!chartReport || Object.keys(chartReport).length === 0"
          elevation="1" color="primary lighten-2" @click="downloadReportPDF(chartReport)" > Download as PDF </v-btn>
        </v-card-actions>

        <div v-if="isPdf" id="mainContent">
          <teacher-report
           :graphImages="graphImages" :printData="printableData"
           :parameter="selectedScaleIds" :module="selectedModuleIds"
           :teacherCount="teacherCount" :chartOptions="chartOptions"
           :scaleList="scaleList" :classWiseModules="classWiseModules"
           :classReports='chartReport'>
          </teacher-report>
        </div>
        <v-card flat class="px-2">
          <v-row>
            <v-col cols="12" md="6" lg="2">
              <v-autocomplete class="my-0 py-1" label="Academic Year *" v-model="academicYearID"
                required item-value="id" :items="academicYears" key="id" item-text="academicYear">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" lg="2">
              <v-autocomplete class="my-0 py-1" label="All Zone *" name="sZone"
                @change="getFranchisee()" v-model="selectedSectionID" required item-text="name"
                item-value="name" :items="selectedZones" key="id" multiple>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" lg="2">
              <v-autocomplete multiple class="my-0 py-1" label="All Centers *" name="sectionSelect"
                v-model="franchiseeID" required item-text="companyName" item-value="id"
                :items="centerList" @change="getClassList" key="id">
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" lg="2">
              <v-autocomplete multiple class="my-0 py-1" label="All Classes *" name="classSelect"
                v-model="selectedClassID" required item-text="name" :items="classesList" key="id"
                return-object>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" lg="2" style="max-width: 12%">
              <v-btn elevation="1" @click="getProgressReport()" color="primary">
                <v-icon left>mdi-content-save</v-icon>
                submit
              </v-btn>
            </v-col>
            <v-col cols="12" md="6" lg="2">
              <v-btn v-if="$vuetify.breakpoint.smAndUp" medium elevation="1" type="reset"
                @click="resetAll()">
                <v-icon left size="18"> mdi-restart</v-icon>
                Reset All
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <v-card-component v-if="progressReportList && progressReportList.length > 0" >
          <div v-for="(item, key) of classWiseModules" :key="key">
            <div >
              <v-row>
                <v-col cols="12">Class : {{ key }} </v-col>
                <v-col cols="12" md="6" lg="2">
                   <v-autocomplete class="my-0 py-1" label="All Terms *" v-model="academicYearID" readonly
                      required item-value="id" :items="academicYears" key="id" item-text="academicYear">
                   </v-autocomplete>
                 </v-col>

                <v-col cols="12" md="6" lg="2">
                   <v-autocomplete
                     multiple
                     label="All Parameter"
                     class="my-0 py-1"
                     v-model="selectedScaleIds[key]"
                     required
                     item-value="gradeScale"
                     :items="scaleList"
                     item-text="gradeScale"
                     >
                   </v-autocomplete>
                 </v-col>

                <v-col cols="12" md="2" lg="2">
                 <v-autocomplete
                      class="my-0 py-1"
                       label="Modules"
                       v-model="selectedModuleIds[key]"
                       :items="item.Module"
                       item-value="moduleID"
                       item-text="module"
                       return-object
                       multiple
                     >
                 </v-autocomplete>
             </v-col>

                <v-col cols="12" md="6" lg="2">
                  <div class="inside">
                    <v-btn elevation="1" @click="getProgressReportV1( key)"
                      :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="primary">
                      <v-icon left>mdi-content-save</v-icon>
                      submit
                    </v-btn>
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                         Total teacher count: {{ teacherCount[key] !== undefined ? teacherCount[key] : item.uniqueEmailCount }}
                </v-col>
                <div v-if="chartReport && chartReport[key]">
                  <v-col cols="12">Class : {{ key }} </v-col>
                  <div style="padding-left:12px;font-size: 15px;" v-if="!isData(chartReport[key])">No report available. Please complete the assessment.</div>
                  <v-row>
                    <v-col >
                      <div class="vertical-divider hidden-sm-and-down pl-1"></div>
                      <div :id="key">
                        <!-- <apexchart type="pie" width="380" :options="chartOptions"
                          :series="seriesCount(chartReport[key])" xaxis></apexchart> -->
                          <GChart
                              type="PieChart"
                              :data="getChartData(chartReport[key])"
                              :options="chartOptions"
                              :resizeDebounce="500"
                            />
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <div v-else>
                  <v-col cols="12">
                    <div style="padding-left:12px;font-size: 15px;">No report available. Please complete the assessment.</div>
                  </v-col>
                </div>
              </v-row>

              <v-divider class="mx-4"></v-divider>
            </div>
          </div>
        </v-card-component>

      </material-card>

      <loading-icon :value="isLoading" />
    </v-container>
  </template>
<script>
import constants from '@/utils/constants'
import domtoimage from 'dom-to-image'
// import moment from 'moment'
import VCardComponent from '@/components/template/VCardComponent'
import MaterialCard from '@/components/template/MaterialCard'
import ExportUtility from '@/utils/exportUtility'
import TeacherReport from './teacherReport.vue'
import { GChart } from 'vue-google-charts/legacy'

export default {
  components: { VCardComponent, MaterialCard, TeacherReport, GChart },
  data () {
    return {
      isLoading: false,
      academicYears: [],
      selectedZones: [],
      centerList: [],
      classesList: [],
      skillsList: [],
      series: [20, 55, 13, 43],
      academicYearID: '',
      selectedSectionID: [],
      franchiseeID: [],
      selectedClassID: [],
      terms: [],
      scaleList: [],
      name: '',
      className: [],
      selectedParameterID: [],
      labelsLoaded: false,
      progressReportList: [],
      isPdf: false,
      printableData: {},
      classReports: [],
      classWiseModules: {},
      graphImages: {},
      loadingComponent: null,
      modulesPerClass: {},
      selectedClasses: [],
      selectedScaleIds: {},
      selectedModuleIds: {},
      chartReport: {},
      data: [],
      pdfParameters: [],
      pdfModule: [],
      teacherCount: {},
      chartWidth: window.innerWidth > 600 ? 600 : window.innerWidth - 20,
      chartHeight: 300,
      chartData: [

      ]
    }
  },
  computed: {
    chartOptions () {
      return {
        chartArea: { width: '90%', height: '90%' },
        width: this.chartWidth,
        height: this.chartHeight,
        tooltip: { trigger: 'focus' },
        // pieSliceText: 'value',
        pieSliceText: 'percentage',
        pieSliceTextStyle: {
          fontSize: 14,
          color: '#000'
        },
        legend: {
          position: 'right',
          textStyle: { fontSize: 12 }
        }
      }
    }
  },
  async created () {
    await this.getAcademicYears()
    // this.getFranchisee()
    this.getZoneDetails()
    this.getScales()
    // this.getProgressReport()
  },
  methods: {
    getChartData (report) {
      const chartData = [['Category', 'Percentage']]
      for (const [key, value] of Object.entries(report)) {
        chartData.push([`${key} - ${value}`, parseFloat(value)])
      }
      return chartData
    },
    seriesCount: function (report) {
      let temp = []
      this.scaleList.forEach((scale) => {
        let scaleName = scale.gradeScale
        if (report.hasOwnProperty(scaleName)) {
          temp.push(parseFloat(report[scaleName]))
        } else {
          temp.push(0)
        }
      })
      return temp
    },

    isData: function (data) {
      if (Object.keys(data).length > 0) {
        return true
      } else {
        return false
      }
    },
    getAcademicYears: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
        this.academicYears = data.rows
        this.academicYearID = this.academicYears[1].id
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(`${constants.API_URL}/api/curriculum_cms/get-zones`)
        this.selectedZones = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getFranchisee: async function () {
      try {
        let zone = this.selectedSectionID
        const response = await http.post(`${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`, {
          zone: zone
        })
        const data = response.data
        this.centerList = data
        this.classReports = []
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching center data', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      } finally {
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        const response = await http.post(`${constants.API_URL}/api/student/franchisee-class-section`, {
          franchiseeID: this.franchiseeID,
          academicYearID: this.academicYearID
        })
        const data = response.data
        this.classesList = data.map((a) => {
          a.term = []
          a.skills = []
          a.subSkills = []
          a.parameter = []
          return a
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    getModules: async function (selectedClasses) {
      try {
        this.isLoading = true
        for (let classItem of selectedClasses) {
          let { data } = await http.post(`${constants.API_URL}/api/report/getModules`, {
            classID: classItem
          })
          this.$set(this.modulesPerClass, classItem, data)
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    getScales: async function () {
      try {
        this.isLoading = true
        let { data } = await http.get(`${constants.API_URL}/api/report/grade-scale`)
        this.scaleList = data
        this.labelsLoaded = true
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getProgressReport: async function (index = -1) {
      let classesid = this.selectedClassID.map((a) => a.id)
      const zoneid = this.selectedZones.filter(zone => this.selectedSectionID.includes(zone.name)).map(zone => zone.id).toString()
      if (this.selectedSectionID.length === 0 && this.franchiseeID.length === 0 && this.selectedClassID.length === 0) {
        this.errMsg('Please ensure all required fields are selected before submitting.')
      } else if (this.selectedSectionID.length === 0) {
        this.errMsg('Please select a Zone.')
      } else if (this.franchiseeID.length === 0) {
        this.errMsg('Please select a Center.')
      } else if (this.selectedClassID.length === 0) {
        this.errMsg('Please select a Class.')
      } else {
        try {
          this.isLoading = true
          let url = `${constants.API_URL}/api/report/teacher-progress-report?franchiseeID=${this.franchiseeID}&classID=${classesid}&zoneID=${zoneid}&academicYearID=${this.academicYearID}`
          let { data } = await http.get(url)
          this.$forceUpdate()
          this.data = data
          this.chartReport = this.data?.countPercentage
          this.progressReportList = this.data?.teacherAssessmentData
          this.classWiseModules = {}
          this.progressReportList.forEach(entry => {
            const classNames = entry.classNames.split(',').map(name => name.trim())

            classNames.forEach(className => {
              if (!this.classWiseModules[className]) {
                this.classWiseModules[className] = {
                  classname: className,
                  Module: [],
                  traineeEmailsSet: new Set(),
                  count: 0
                }
              }

              this.classWiseModules[className].traineeEmailsSet.add(entry.traineeemail)
              this.classWiseModules[className].count++

              const existingModule = this.classWiseModules[className].Module.find(mod => mod.module === entry.Module && mod.moduleID === entry.moduleID)

              if (!existingModule) {
                this.classWiseModules[className].Module.push({
                  module: entry.Module,
                  moduleID: entry.moduleID
                })
              }
            })
          })

          for (const className in this.classWiseModules) {
            const uniqueEmailCount = this.classWiseModules[className].traineeEmailsSet.size
            this.classWiseModules[className].uniqueEmailCount = uniqueEmailCount
            delete this.classWiseModules[className].traineeEmailsSet
          }

          this.getModules(this.selectedClassID.map(item => item.id))
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        } finally {
          this.isLoading = false
        }
      }
    },
    getProgressReportV1: async function (item) {
      let classesid = this.classesList.find(cls => cls.name === item)?.id
      const zoneid = this.selectedZones.filter(zone => this.selectedSectionID.includes(zone.name)).map(zone => zone.id).toString()
      let url = `${constants.API_URL}/api/report/teacher-progress-report?franchiseeID=${this.franchiseeID}&classID=${classesid}&zoneID=${zoneid}&academicYearID=${this.academicYearID}`
      if (this.selectedScaleIds[item]) {
        let scaleIds = this.selectedScaleIds[item].join(',')
        if (scaleIds) {
          url += `&parameters=${scaleIds}`
        }
      }
      if (this.selectedModuleIds[item]) {
        let moduleid = this.selectedModuleIds[item].map(scale => scale.moduleID).join(',')
        if (moduleid) {
          url += `&moduleID=${moduleid}`
        }
      }
      if (this.selectedSectionID.length === 0 && this.franchiseeID.length === 0 && this.selectedClassID.length === 0) {
        this.errMsg('Please ensure all required fields are selected before submitting.')
      } else if (this.selectedSectionID.length === 0) {
        this.errMsg('Please select a Zone.')
      } else if (this.franchiseeID.length === 0) {
        this.errMsg('Please select a Center.')
      } else if (this.selectedClassID.length === 0) {
        this.errMsg('Please select a Class.')
      } else {
        try {
          this.isLoading = true
          let { data } = await http.get(url)

          let uniqueTeacherEmails = new Set()
          data.teacherAssessmentData.forEach(entry => {
            uniqueTeacherEmails.add(entry.traineeemail)
          })

          this.teacherCount[item] = uniqueTeacherEmails.size

          if (data.countPercentage.hasOwnProperty(item)) {
            this.data.countPercentage[item] = data.countPercentage[item]
          } else {
            delete this.data.countPercentage[item]
          }
          this.chartReport = this.data?.countPercentage
          this.$forceUpdate()
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        } finally {
          this.isLoading = false
        }
      }
    },
    downloadReportPDF: async function (reportList) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.graphImages = {}
        for (let key in reportList) {
          let ele = document.getElementById(key)
          if (ele) {
            this.graphImages[key] = await domtoimage.toPng(ele)
          }
        }
        this.isPdf = true
        this.printableData = reportList

        this.$nextTick(() => {
          this.printInvoice('printableAreas')
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data?.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.loadingComponent.close()
      }
    },

    printInvoice: async function (content) {
      this.prtHtml = document.getElementById(content).innerHTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=1300,toolbar=0,scrollbars=0,status=0')

      WinPrint.document.write(`<!DOCTYPE html>
        <html>
        <head>
        ${stylesHtml}
        </head>
        <body>
        ${this.prtHtml}
        </body>
        <style>
  
        @media print {
        .page-break {
        height: 0;
        page-break-before: always;
        margin: 0;
        border-top: none;
        }
        }
  
        body, p{
        font-size: 9pt;
        font-family: Arial, Helvetica, sans-serif;
        }
  
        body {
        margin-left: 2em;
        margin-right: 2em;
        padding-left: 2em;
        }
  
        .card{
        padding-left: 2em;
        }
  
        .page {
        height: 1300px;
        padding-top: 5px;
        page-break-after: always;
        font-family: Arial, Helvetica, sans-serif;
        position: relative;
        border-bottom: 1px solid #000;
        }
        </style>
        </html>`)

      WinPrint.document.close()

      WinPrint.focus()

      setTimeout(function () {
        WinPrint.print()
      }, 500)

      this.resetResult()
    },

    resetResult () {
      this.printableData = {}
      this.isPdf = false
    },
    getteacherCount (report, termId = null) {
      let terms = Object.keys(report)
      return terms.reduce((acc, term) => {
        if (termId) {
          // term wise student count
          if (report[term][0].AcademicTermMapID === termId) {
            return (
              acc +
            report[term].reduce((termStudentCount, a) => {
              return termStudentCount + Number(a.Students)
            }, 0)

            )
          } else {
            return acc
          }
        } else {
          // total student count
          return (
            acc +
            report[term].reduce((termStudentCount, a) => {
              return termStudentCount + Number(a.Students)
            }, 0)

          )
        }
      }, 0)
    },
    resetAll: function () {
      this.selectedSectionID = []
      this.franchiseeID = []
      this.selectedClassID = []
      this.selectedScaleIds = {}
      this.selectedModuleIds = {}
      this.classReports = []
      this.classWiseModules = {}
      this.progressReportList = []
      this.centerList = []
      this.classesList = []
      this.chartReport = {}
      this.$forceUpdate()
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    downloadReportCSV: function (progressReportList) {
      const csvData = []
      progressReportList.forEach((data, index) => {
        csvData.push({
          Sr_No: index + 1,
          Participant_Name: data.traineename,
          Email_ID: data.traineeemail,
          Contact_No: data.mobile,
          Center_Name: data.CentreName,
          Zone: data.Zone,
          Score: data.score,
          OutOf: data.total,
          Status: data.status,
          Module_Name: data.Module,
          No_of_Attempts: data.attempt
        })
      })
      ExportUtility.convertToCsv(csvData, 'Teacher_Assessment_Report')
    }
  }
}
</script>
  <style scoped>
  .to-bottom {
    align-self: flex-end;
  }

  @media print {
    #mainContent {
      position: absolute;
      width: 100%;
      min-height: 100vh;
      top: 0;
      left: 0;
    }
  }

  .button-container {
    position: absolute;
    width: 100%;
    top: 0px;
    right: 0;
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
}
svg > g > g:nth-child(even) { pointer-events: none }
svg > g > g.google-visualization-tooltip { pointer-events: none; }
@media (max-width: 850px) {
    .button-container {
        position: relative;
        top: -30px;
    }
}
  </style>
